import React from 'react';
import ValidateDataResultsDictionaryHeader from './ValidateDataResultsDictionaryHeader';

const ValidateDataResultsPanelContent = ({
  children,
  dictionaryName,
  valid,
  validate,
  loading,
}) => (
  <>
    <ValidateDataResultsDictionaryHeader
      dictionaryName={dictionaryName}
      valid={valid}
      validate={validate}
      loading={loading}
    />
    {children}
  </>
);

export default ValidateDataResultsPanelContent;
